import { Action, createReducer, on } from "@ngrx/store";
import { FreePlayLobbyState, INIT_FREE_PLAY_LOBBY_STATE } from "./freePlayLobby.state";
import * as FreePlayLobbyActions from './freePlayLobby.actions';

const _freePlayLobbyReducer = createReducer(

    INIT_FREE_PLAY_LOBBY_STATE,

    on(
        FreePlayLobbyActions.addRingConfig,
        (state, action) => {
            let updatedRingConfigs = [...state['ringConfigs'].configArray];

            updatedRingConfigs.push({...action.ringConfig});

            return {
                ...state,
                ['ringConfigs']: {
                    configArray: updatedRingConfigs,
                    loading: false,
                }
            }
        }
    ),

    on(
        FreePlayLobbyActions.addSngConfig,
        (state, action) => {
            let updatedSngConfigs = [...state['sngConfigs'].configArray];

            updatedSngConfigs.push({...action.sngConfig});

            return {
                ...state,
                ['sngConfigs']: {
                    configArray: updatedSngConfigs,
                    loading: false,
                }
            }
        }
    ),

    on(
        FreePlayLobbyActions.addMttConfig,
        (state, action) => {
            let updatedMttConfigs = [...state['mttConfigs'].configArray];

            updatedMttConfigs.push({...action.mttConfig});

            return {
                ...state,
                ['mttConfigs']: {
                    configArray: updatedMttConfigs,
                    loading: false,
                }
            }
        }
    ),

    on(
        FreePlayLobbyActions.removeRingConfig,
        (state, action) => {
            const remainingRingConfigs = state['ringConfigs'].configArray.filter((config) => config.gameConfigId !== action.gameConfigId);

            return {
                ...state,
                ['ringConfigs']: {
                    loading: state['ringConfigs'].loading,
                    configArray: remainingRingConfigs,
                }
            }
        }
    ),

    on(
        FreePlayLobbyActions.removeSngConfig,
        (state, action) => {
            const remainingSngConfigs = state['sngConfigs'].configArray.filter((config) => config.gameConfigId !== action.gameConfigId);

            return {
                ...state,
                ['sngConfigs']: {
                    configArray: remainingSngConfigs,
                    loading: state['sngConfigs'].loading,
                }
            }
        }
    ),

    on(
        FreePlayLobbyActions.removeMttConfig,
        (state, action) => {
            const remainingMttConfigs = state['mttConfigs'].configArray.filter((config) => config.gameConfigId !== action.gameConfigId);

            return {
                ...state,
                ['mttConfigs']: {
                    configArray: remainingMttConfigs,
                    loading: state['mttConfigs'].loading,
                }
            }
        }
    ),

    on(
        FreePlayLobbyActions.resetState,
        (state) => ({...state, ['ringConfigs']: {configArray: [], loading: true}, ['sngConfigs']: {configArray: [], loading: true}, ['mttConfigs']: {configArray: [], loading: true}})
    ),

    on(
        FreePlayLobbyActions.rngConfigLoaded,
        (state) => ({
            ...state,
            ringConfigs: {
                ...state.ringConfigs,
                loading: false,
            }
        })
    ),

    on(
        FreePlayLobbyActions.sngConfigLoaded,
        (state) => ({
            ...state,
            sngConfigs: {
                ...state.sngConfigs,
                loading: false,
            }
        })
    ),

    on(
        FreePlayLobbyActions.mttConfigLoaded,
        (state) => ({
            ...state,
            mttConfigs: {
                ...state.mttConfigs,
                loading: false,
            }
        })
    ),
);

export function freePlayLobbyReducer(state: FreePlayLobbyState, action: Action) {
    return _freePlayLobbyReducer(state, action);
}